import { createFileRoute } from "@tanstack/react-router";
import { SchoolsPage } from "@/components/schools/SchoolsPage";
import { schoolsHead } from "@/components/schools/schools-head";

// Страница «Школам» (az) — программы для школ, FAQ и форма заявки школы (30.10.2026).
export const Route = createFileRoute("/az/mektebler")({
  head: () => schoolsHead("az"),
  component: () => <SchoolsPage lang="az" />,
});
